import { SVGProps } from "react";

export const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.5 8.66235L2.5 17.2917C2.5 18.0971 3.05965 18.75 3.75 18.75H16.25C16.9404 18.75 17.5 18.0971 17.5 17.2917V8.66235C17.5 8.25358 17.353 7.86357 17.0946 7.58734L10 1.25L2.90535 7.58734C2.64706 7.86357 2.5 8.25358 2.5 8.66235Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 12.9165V18.7498" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
